<div class="page">
    <div class="page-head">
        <div>
            <h2>{{ pageTitle() || 'KYC Pending' }}</h2>
            <p>Partners whose KYC is not done yet. Review to approve or reject.</p>
        </div>
    </div>

    <div class="card">
        <div class="toolbar">
            <p-iconfield iconPosition="left" class="search-field">
                <p-inputicon styleClass="pi pi-search" />
                <input type="text" pInputText placeholder="Search partner, code, contact, phone..."
                    [ngModel]="search()" (ngModelChange)="search.set($event)" />
            </p-iconfield>
            <div class="filter">
                <label>KYC State</label>
                <p-select [ngModel]="state()" (ngModelChange)="onState($event)" [options]="stateOptions"
                    optionLabel="label" optionValue="value" appendTo="body" />
            </div>
            <p-button icon="pi pi-refresh" [rounded]="true" [text]="true" severity="secondary"
                pTooltip="Refresh" (onClick)="load()" [loading]="loading()" />
            <span class="count">{{ filtered().length }} of {{ rows().length }}</span>
        </div>

        <p-table [value]="filtered()" [loading]="loading()" dataKey="partnerId" [rows]="10"
            [paginator]="filtered().length > 10" [rowsPerPageOptions]="[10, 25, 50]"
            styleClass="p-datatable-sm" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
            <ng-template pTemplate="header">
                <tr>
                    <th>Partner</th>
                    <th>Contact</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>KYC Status</th>
                    <th>Submitted On</th>
                    <th class="ta-r">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-r>
                <tr>
                    <td class="name">
                        {{ r.partnerName }}
                        @if (r.partnerCode) { <span class="mono">{{ r.partnerCode }}</span> }
                    </td>
                    <td>{{ r.contactPerson || '—' }}</td>
                    <td>{{ r.phone || '—' }}</td>
                    <td>{{ r.email || '—' }}</td>
                    <td><p-tag [value]="r.kycStatus" [severity]="statusSeverity(r.kycStatus)" /></td>
                    <td>{{ r.submittedDate | indDate }}</td>
                    <td class="ta-r">
                        <p-button label="Review" icon="pi pi-eye" [outlined]="true" size="small"
                            (onClick)="review(r)" />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">
                        <div class="state"><i class="pi pi-check-circle"></i>
                            <p>No partners match this filter.</p>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
